var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCocktail2 = function SvgCocktail2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8CBD9"
    },
    d: "M160.649,0h-54.92c-5.542,0-10.034,4.492-10.034,10.034v63.45h74.987v-63.45 C170.683,4.492,166.191,0,160.649,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2C3CE"
    },
    d: "M160.649,0h-47.001v73.484h57.034v-63.45C170.683,4.492,166.191,0,160.649,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDBE7"
    },
    d: "M233.545,161.363l-22.229-59.344c-2.809-7.498-8.049-13.838-14.885-18.007l-25.708-15.68H95.656 l-25.708,15.68c-6.835,4.169-12.076,10.509-14.885,18.007l-22.229,59.344l0,0l0,0l0,0l0,0l2.784,110.836 c0.021,0.846,0.074,1.69,0.158,2.532l22.58,225.764C59.009,507.026,64.505,512,71.07,512h124.24c6.564,0,12.06-4.974,12.714-11.505 l22.579-225.764c0.084-0.842,0.137-1.686,0.158-2.532L233.545,161.363L233.545,161.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8CBD9"
    },
    d: "M211.316,102.018c-2.809-7.498-8.049-13.838-14.885-18.007l-25.708-15.68h-57.075l25.708,15.68 c6.835,4.169,12.076,10.509,14.885,18.007l22.229,59.344l0,0l-2.784,110.836c-0.021,0.846-0.074,1.69-0.158,2.532l-22.579,225.764 c-0.653,6.531-6.149,11.505-12.714,11.505h57.075c6.564,0,12.06-4.974,12.714-11.505l22.579-225.764 c0.084-0.842,0.137-1.686,0.158-2.532l2.784-110.836l0,0L211.316,102.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2C3CE"
    },
    d: "M237.122,181.103H29.257c-4.031,0-7.299-3.268-7.299-7.299v-14.927c0-4.031,3.268-7.299,7.299-7.299 h207.865c4.031,0,7.299,3.268,7.299,7.299v14.927C244.421,177.836,241.153,181.103,237.122,181.103z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDC74F"
    },
    cx: 291.65,
    cy: 262.36,
    r: 35.14
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8CBD9"
    },
    d: "M390.848,500.855c-4.27,0-7.73-3.461-7.73-7.73V324.097c0-4.269,3.46-7.73,7.73-7.73 s7.73,3.461,7.73,7.73v169.028C398.578,497.394,395.118,500.855,390.848,500.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E0DC"
    },
    d: "M451.976,509.042l-57.964-24.378c-2.023-0.851-4.304-0.851-6.327,0l-57.964,24.378 c-1.547,0.652-1.081,2.958,0.598,2.958h121.06C453.057,512,453.523,509.694,451.976,509.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFEDE7"
    },
    d: "M386.181,372.286L292.778,269.53c-2.503-2.754-0.549-7.17,3.172-7.17h189.797 c3.721,0,5.675,4.416,3.172,7.17l-93.403,102.755C393.013,375.039,388.684,375.039,386.181,372.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E0DC"
    },
    d: "M485.747,262.361h-52.779l-73.353,80.698l26.567,29.227c2.503,2.753,6.833,2.753,9.335,0 l93.403-102.755C491.422,266.777,489.468,262.361,485.747,262.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0EFFE"
    },
    d: "M465.516,295.277H316.181l70,77.009c2.503,2.753,6.833,2.753,9.335,0L465.516,295.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0E0EA"
    },
    d: "M390.879,374.349c0.952-0.005,1.899-0.229,2.77-0.661c0.683-0.339,1.32-0.801,1.867-1.402 l66.363-73.009l3.636-4h-62.469l-43.433,47.782l10.599,11.66l15.968,17.567c1.251,1.377,2.96,2.065,4.668,2.065 C390.859,374.351,390.869,374.349,390.879,374.349z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCocktail2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cocktail-2.1a80734e.svg";
export { ForwardRef as ReactComponent };